import React from 'react';
import { Stack, Text } from 'library/ui';

export function BlockedCountyNotice() {
    return (
        <Stack gap="md">
            <Text weight="bold">Important: Substitute Shifts Temporarily Paused</Text>
            <Text size="sm" component="p" lineHeight="relaxed">
                The Florida Department of Early Learning recently issued guidance regarding background screening
                requirements for substitutes working through staffing agencies like Tandem. While we work directly with
                DEL to understand how this guidance applies to Tandem’s substitute model and determine the appropriate
                path forward, we are temporarily pausing substitute services.
            </Text>
            <Text size="sm" component="p" lineHeight="relaxed">
                Effective immediately, we are:
            </Text>
            <ul style={{ margin: 0, paddingLeft: 20 }}>
                <li>
                    <Text size="sm" lineHeight="relaxed">
                        Pausing new substitute shift postings
                    </Text>
                </li>
                <li>
                    <Text size="sm" lineHeight="relaxed">
                        Canceling upcoming Tandem substitute shifts
                    </Text>
                </li>
                <li>
                    <Text size="sm" lineHeight="relaxed">
                        Temporarily preventing new shifts from being scheduled until this matter is resolved
                    </Text>
                </li>
            </ul>
            <Text size="sm" component="p" lineHeight="relaxed">
                We know this is disruptive and apologize for the inconvenience. We will update you as soon as we have
                clarity and are able to resume service.
            </Text>
            <Text size="sm" component="p" lineHeight="relaxed">
                For questions, please contact team@join-tandem.com.
            </Text>
        </Stack>
    );
}
